<div class="modal-container">
  <topo-modal
    (close)="close()"
    [isActive]="showPage === true"
    [hideFooter]="false"
    [isCard]="true">
    <div class="modal-header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <h5 class="mx-4 my-4">
          {{ 'LOGIN.POLICY-ACCEPTANCE' | translate }}
        </h5>
      </div>
    </div>
    <div class="modal-body body">
      @for (section of sections; track section.uId) {
        <div>
          <div
            fxLayout="row"
            fxLayoutAlign="start top"
            class="section">
            <div class="checkbox">
              <topo-checkbox
                [checked]="section.checked"
              (checkChanged)="onSectionChecked(section, $event)"></topo-checkbox>
            </div>
            <div>
              <quill-view
                [content]="section.text"
              format="html"></quill-view>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="end"
        class="mt-4 mb-4">
        <div>
          <button
            class="button is-primary"
            [disabled]="!allChecked()"
            (click)="continueClick()">
            {{ 'LOGIN.SAVE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </topo-modal>
</div>
